<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed" >
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>统计</el-breadcrumb-item>
        </el-breadcrumb>
        <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
        <el-option
            v-for="item in DianList"
            :key="item.ID"
            :label="item.StoresName"
            :value="item.ID">
        </el-option>
        </el-select>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="padding-top:30px">
        <el-tab-pane :label="'提成统计'" name="0" v-if="q1 == true && iscdyy==0 && iszjyy==0">
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="本月" value="0"></el-option>
                                    <el-option label="上月" value="1"></el-option>
                                    <el-option label="自定义" value="2"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                  <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='2'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='2'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker>
                            
                                &nbsp;&nbsp;
                               
                                 <el-select v-model="objID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in proList"
                                        :key="item.ID"
                                        :label="item.ProjectName"
                                        :value="item.ID"
                                      ></el-option>
                                 </el-select>
                                 &nbsp;&nbsp;
                                  <el-select v-model="TerID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>

                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="list" highlight-current-row v-loading="loading" size="mini"  show-summary  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="StaffName" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone11" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>
                </el-table-column>
                <el-table-column :label="WZXMName+'名称'" prop="ProjectName" ></el-table-column>
                <el-table-column label="服务次数"  prop="allcount" ></el-table-column>         
                <el-table-column label="服务总人数" prop="sumPreAboutCount"></el-table-column>
                <el-table-column label="提成金额" prop="tcAmount"></el-table-column>
                <el-table-column align="center" label="操作" prop="tcAmount123">
                   <template slot-scope="scope">
                      <el-button  size="mini" type="primary"  v-if="scope.row.tcAmount == 0 && scope.row.StaffID != 0" @click="ticheng(scope.row)">编辑提成</el-button>
                       <el-button  size="mini" type="primary" disabled  v-else @click="ticheng(scope.row)">编辑提成</el-button>
                   </template>
                </el-table-column>
            </el-table>
         
        </el-tab-pane>
        <el-tab-pane :label="'直接提成统计'" name="0" v-if="q1 == true && iscdyy==0 && iszjyy==1">
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="本月" value="0"></el-option>
                                    <el-option label="上月" value="1"></el-option>
                                    <el-option label="自定义" value="2"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                  <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='2'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='2'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker>
                             
                                &nbsp;&nbsp;
                               
                                 <el-select v-model="objID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in proList"
                                        :key="item.ID"
                                        :label="item.ProjectName"
                                        :value="item.ID"
                                      ></el-option>
                                 </el-select>
                                 &nbsp;&nbsp;
                                  <el-select v-model="TerID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>

                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="list" highlight-current-row v-loading="loading" size="mini"  show-summary  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="StaffName" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone11" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>
                </el-table-column>
                <el-table-column :label="WZXMName+'名称'" prop="ProjectName" ></el-table-column>
                <el-table-column label="服务次数"  prop="allcount" ></el-table-column>         
                <el-table-column label="服务总人数" prop="sumPreAboutCount"></el-table-column>
                <el-table-column label="提成金额" prop="tcAmount"></el-table-column>
                <el-table-column align="center" label="操作" prop="tcAmount123">
                   <template slot-scope="scope">
                      <el-button  size="mini" type="primary"  v-if="scope.row.tcAmount == 0 && scope.row.StaffID != 0" @click="ticheng(scope.row)">编辑提成</el-button>
                       <el-button  size="mini" type="primary" disabled  v-else @click="ticheng(scope.row)">编辑提成</el-button>
                   </template>
                </el-table-column>
            </el-table>
         
        </el-tab-pane>
        <el-tab-pane :label="'提成统计'" name="0" v-if="q1 == true && iscdyy==1 ">
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="本月" value="0"></el-option>
                                    <el-option label="上月" value="1"></el-option>
                                    <el-option label="自定义" value="2"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                  <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='2'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='2'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker>
                                &nbsp;&nbsp;
                               
                                 <el-select v-model="objID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in proList1"
                                        :key="item.ID"
                                        :label="item.SiteName"
                                        :value="item.ID"
                                      ></el-option>
                                 </el-select>
                                 &nbsp;&nbsp;
                                  <el-select v-model="TerID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>

                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="list" highlight-current-row v-loading="loading" size="mini"  show-summary  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="StaffName" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone11" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>
                </el-table-column>
                <el-table-column :label="WZCDName+'名称'" prop="SiteName" ></el-table-column>
                <el-table-column label="服务次数"  prop="allcount" ></el-table-column>         
                <el-table-column label="服务总人数" prop="sumPreAboutCount"></el-table-column>
                <el-table-column label="提成金额" prop="tcAmount"></el-table-column>
                <el-table-column align="center" label="操作" prop="tcAmount123">
                   <template slot-scope="scope">
                      <el-button  size="mini" type="primary"  v-if="scope.row.tcAmount == 0 && scope.row.StaffID != 0" @click="ticheng1(scope.row)">编辑提成</el-button>
                       <el-button  size="mini" type="primary" disabled  v-else @click="ticheng1(scope.row)">编辑提成</el-button>
                   </template>
                </el-table-column>
            </el-table>
         
        </el-tab-pane>
         <el-tab-pane :label="WZCDName+'分类统计'" name="5" v-if=" iscdyy == 1">            
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                     <el-option label="本月" value="0"></el-option>
                                    <el-option label="上月" value="1"></el-option>
                                    <el-option label="自定义" value="2"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                    <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='2'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='2'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                                 <el-select v-model="SiteTypeID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in typeList"
                                        :key="item.ID"
                                        :label="item.SiteTypeName"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>
                                                           
                            </div>
                </div>
            </div>
            <el-table :data="list5" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZCDName+'分类名称'" prop="SiteTypeName" ></el-table-column>
                 <el-table-column label="预约次数"  prop="allcount" ></el-table-column>
            </el-table>
        </el-tab-pane>
           <el-tab-pane :label="WZCDName+'统计'" name="6" v-if="iscdyy == 1">            
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                     <el-option label="本月" value="0"></el-option>
                                    <el-option label="上月" value="1"></el-option>
                                    <el-option label="自定义" value="2"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                    <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='2'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='2'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                                 <el-select v-model="SiteID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in ListSite"
                                        :key="item.ID"
                                        :label="item.SiteName"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>
                                                           
                            </div>
                </div>
            </div>
            <el-table :data="list6" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZCDName+'名称'" prop="SiteName" ></el-table-column>
                 <el-table-column label="预约次数"  prop="allcount" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane :label="'售卡营业额统计'" name="1" v-if="q2 == true  && isCard == 1">            
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                    <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                                 <el-select v-model="SelectCardID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in cardList"
                                        :key="item.ID"
                                        :label="item.CardName"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>
                                
                                  <el-select v-model="TerID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>                              
                            </div>
                </div>
            </div>
            <el-table :data="list1" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone321" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>
                   
                </el-table-column>
                <el-table-column label="会有卡名称" prop="CradName" ></el-table-column>
                <el-table-column label="售卡张数"  prop="allCountsk" ></el-table-column>
                <el-table-column label="售卡营业额"  prop="allAmountsk" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane :label="'充值营业额统计'" name="1" v-if="q2 == true  && isCard == 0">            
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                  <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                           
                                
                                  <el-select v-model="TerID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>                              
                            </div>
                </div>
            </div>
            <el-table :data="list1" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone321" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>

                </el-table-column>
                <el-table-column label="会有卡名称" prop="CradName" ></el-table-column>
                <el-table-column label="充值次数"  prop="allCountsk" ></el-table-column>
                <el-table-column label="充值营业额"  prop="allAmountsk" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员卡销售统计" name="2" v-if="q3 == true  && isCard == 1">           
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                   <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                                               <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                                 <el-select v-model="SelectCardID" clearable placeholder="请选择" @change="handleSearchCoursetopsy"  size="mini">
                                   <el-option v-for="item in cardList"
                                        :key="item.ID"
                                        :label="item.CardName"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>


                               
                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="list2" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column label="会员卡名称" prop="CradName" ></el-table-column>
                            <el-table-column label="售卡张数" prop="allCountsk" ></el-table-column>
                            <el-table-column label="售卡金额"  prop="allAmountsk" ></el-table-column>
                            <el-table-column label="续卡张数"  prop="allCountxf" ></el-table-column>
                            <el-table-column label="续卡金额"  prop="allAmountxf" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="销售排行榜" name="3" v-if="q4 == true && isCard == 1" > 
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                   <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                     <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                  <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                                   <el-select v-model="OrderType" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option label="售卡" value="1"></el-option>
                                    <el-option label="续卡" value="2"></el-option>
                                </el-select>&nbsp;&nbsp;
                              
                                                                
                            </div>
                </div>
            </div>
               <el-tabs v-model="activeNamesk" @tab-click="handleClick1" class="topTabs1">

                <el-tab-pane  label="售卡排行榜" name="skphb" >
                    <el-table :data="list3"  
                    size="small"
                    show-summary
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                            <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                            <el-table-column :label="WZYGName+'手机'" prop="Phone123" >
                               <template slot-scope="scope">
                              <span>{{scope.row.Phone}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column label="售卡次数" prop="allCountsk" ></el-table-column>
                            <el-table-column label="续卡次数" prop="allCountxq" ></el-table-column>
                            <el-table-column label="总次数" prop="allCount" ></el-table-column>
 
                        </el-table>   
                </el-tab-pane>
                <el-tab-pane  label="营业额排行榜" name="yyephb"  >
                    <el-table :data="list3" 
                    show-summary
                      size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                            <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                            <el-table-column :label="WZYGName+'手机'" prop="Phone123" >
                               <template slot-scope="scope">
                                <span>{{scope.row.Phone}}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="售卡金额" prop="allAmountsk" ></el-table-column>
                            <el-table-column label="续卡金额" prop="allAmountxq" ></el-table-column>
                            <el-table-column label="总金额" prop="allAmount" ></el-table-column>
 
                        </el-table>   
                  </el-tab-pane>
              </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="销售排行榜" name="3" v-if="q4 == true && isCard == 0" > 
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                   <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                  <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                  <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                             
                              
                                                                
                            </div>
                </div>
            </div>
               <el-tabs v-model="activeNamesk" @tab-click="handleClick1" class="topTabs1">
                <el-tab-pane  label="营业额排行榜" name="yyephb"  >
                    <el-table :data="list3" 
                    show-summary
                      size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                            <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                            <el-table-column :label="WZYGName+'手机'" prop="Phone123" >
                               <template slot-scope="scope">
                                <span>{{scope.row.Phone}}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="充值储蓄卡次数" prop="allCountcx" ></el-table-column>
                            <el-table-column label="充值储次卡次数" prop="allCountck" ></el-table-column>
                            <el-table-column label="总金额" prop="allAmount" ></el-table-column>
 
                        </el-table>   
                  </el-tab-pane>
              
              </el-tabs>
        </el-tab-pane>
       <el-tab-pane label="收银营业额统计" name="4" v-if="isCashier == 1">            
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 
                                    <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker> &nbsp;&nbsp;
                              
                                
                                  <el-select v-model="TerID" placeholder="请选择" @change="handleSearchCoursetopsy" clearable  size="mini">
                                   <el-option v-for="item in personList"
                                        :key="item.ID"
                                        :label="item.Name"
                                        :value="item.ID"
                                      ></el-option>&nbsp;&nbsp;
                                 </el-select>                              
                            </div>
                </div>
            </div>
            <el-table :data="list4" highlight-current-row v-loading="loading" size="mini" show-summary   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column :label="WZYGName+'名称'" prop="Name" ></el-table-column>
                <el-table-column :label="WZYGName+'手机'" prop="Phone321" >
                   <template slot-scope="scope">
                     <span>{{scope.row.Phone}}</span>
                   </template>

                </el-table-column>
                <el-table-column label="提成" prop="allTC" ></el-table-column>
                <el-table-column align="center" label="操作" prop="tcAmount123">
                   <template slot-scope="scope">
                      <el-button  size="mini" type="primary"   @click="lookInfo(scope.row)">查看详情</el-button>
                     
                   </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员上课费用" name="10" v-if="isCard == 1">           
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype"   size="mini">
                                   <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                  </el-select>&nbsp;&nbsp;
                                 

                                    <el-date-picker
                                    v-model="sTime"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     >
                                  </el-date-picker>
                                    <span style="font-size:14px">至</span>
                                  <el-date-picker
                                    v-model="eTime"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     >
                                  </el-date-picker> &nbsp;&nbsp;
                               
                           <el-input size="mini"  style="width:170px" v-model="SelectName" placeholder="输入姓名、手机号"></el-input>
                           &nbsp;&nbsp;
                           <el-button size="mini" type="primary" icon="el-icon-search" @click="searchHYSKFY">搜索</el-button>
                                
                            </div>
                </div>
            </div>
            <el-table :data="list10" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
              <el-table-column label="姓名" prop="Name">
                                <template slot-scope="scope"  >
                                    <span  >{{scope.row.Name}} {{scope.row.Phone}}</span>
                                </template>
                            </el-table-column>
                        
                            <el-table-column label="会员卡"  prop="CardName" >
                                  <template slot-scope="scope">
                                   <span >{{scope.row.CardName}}</span>
                                </template>
                             </el-table-column>
                             <el-table-column label="会员卡类型" prop="CardType">
                                 <template slot-scope="scope"  >
                                    <span v-if="scope.row.CardType==1 || scope.row.CardType==2">次卡</span>
                                    <span v-if="scope.row.CardType==3">期限卡</span>
                                    <span v-if="scope.row.CardType==4 || scope.row.CardType==5">储蓄卡</span>
                                    <span v-if="scope.row.OrderType==2 ">续卡</span>
                                </template>
                             </el-table-column>
                             <el-table-column label="消耗" prop="xhValue">
                                <template slot-scope="scope"  >
                                    <span style="font-weight:700;font-size:15px;color:#1890ff;cursor:pointer" @click="getOrderRecordTJClick(scope.row)" v-if="scope.row.CardType==1 || scope.row.CardType==2">{{scope.row.sumNumber}}</span>
                                    <span style="font-weight:700;font-size:15px;color:#1890ff;cursor:pointer" @click="getOrderRecordTJClick(scope.row)" v-if="scope.row.CardType==3">{{scope.row.allCount}}</span>
                                    <span style="font-weight:700;font-size:15px;color:#1890ff;cursor:pointer" @click="getOrderRecordTJClick(scope.row)" v-if="scope.row.CardType==4 || scope.row.CardType==5">{{scope.row.sumAmount}}</span>
                                </template>
                             </el-table-column>
                             <el-table-column label="单价" prop="djValue">
                             </el-table-column>
                            <el-table-column label="费用" prop="Amount"></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员卡费用统计" name="11" v-if="isCard == 1">           
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                        <div class="flexS">
                           <el-input size="mini"  style="width:170px" v-model="SelectName" placeholder="输入姓名、手机号"></el-input>
                           &nbsp;&nbsp;
                           <el-button size="mini" type="primary" icon="el-icon-search" @click="searchHYFY">搜索</el-button>
                              
                        </div>
                </div>
            </div>
            <el-table :data="list11" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                          <el-table-column label="姓名" prop="Name">
                                <template slot-scope="scope" >
                                    <span style="font-weight:700;font-size:15px;color:#1890ff"  >{{scope.row.Name}} {{scope.row.Phone}}</span>
                                </template>
                            </el-table-column>
                        
                            <el-table-column label="会员卡"  prop="CardName" >
                                  <template slot-scope="scope">
                                   <span >{{scope.row.CardName}}</span>
                                </template>
                             </el-table-column>
                             <el-table-column label="会员卡类型" prop="CardType">
                                 <template slot-scope="scope" >
                                    <span v-if="scope.row.CardType==1 || scope.row.CardType==2">次卡</span>
                                    <span v-if="scope.row.CardType==3">期限卡</span>
                                    <span v-if="scope.row.CardType==4 || scope.row.CardType==5">储蓄卡</span>
                                 </template>
                             </el-table-column>
                          
                             <el-table-column label="开卡时间" prop="KaiKaTime">
                             </el-table-column>
                            <el-table-column label="余额" prop="Amount">
                                <template slot-scope="scope" >
                                    <span v-if="scope.row.CardType==1 || scope.row.CardType==2">{{scope.row.CardNumber}}次</span>
                                    <span v-if="scope.row.CardType==3"></span>
                                    <span v-if="scope.row.CardType==4 || scope.row.CardType==5">{{scope.row.CardNumber}}元</span>
                                 </template>
                            </el-table-column>
                            <el-table-column label="消耗金额" prop="HKallAmount">
                                <template slot-scope="scope" >
                                     <span >{{scope.row.HKallAmount}}元</span>
                                 </template>
                            </el-table-column>
                            <el-table-column label="剩余金额" prop="allAmount">
                                <template slot-scope="scope" >
                                     <span >{{scope.row.allAmount}}元</span>
                                 </template>
                            </el-table-column>
                            <el-table-column label="总金额" prop="allYSAmount">
                                <template slot-scope="scope" >
                                     <span >{{scope.row.allYSAmount}}元</span>
                                 </template>
                            </el-table-column>
                            <el-table-column label="发卡时间" prop="GMtime"></el-table-column>
                            <el-table-column label="到期时间" prop="OverdueTime">
                                <template slot-scope="scope" >
                                    <span v-if="scope.row.CardType==1 || scope.row.CardType==3 || scope.row.CardType==5">{{scope.row.OverdueTime}}次</span>
                                     <span v-else>无限期</span>
                                 </template>
                            </el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员剩余课时" name="12" v-if="isCard == 1" > 
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                  <div class="flexS">
                                 <span v-if="activeNamesyks==1 || activeNamesyks==2" style="font-size: 12px;width:60px;margin-top:5px">剩余次数≥</span>
                                <el-input  v-if="activeNamesyks==1 || activeNamesyks==2"  size="mini" style="width:80px;"   v-model="CardNumber2" ></el-input>
                                <span  v-if="activeNamesyks==1 || activeNamesyks==2" style="font-size: 12px;width:60px;margin-top:5px">剩余次数≤</span>
                              <el-input  v-if="activeNamesyks==1 || activeNamesyks==2" size="mini" style="width:80px;"   v-model="CardNumber1" ></el-input>
                                  <span  v-if="activeNamesyks==4 || activeNamesyks==5" style="font-size: 12px;width:60px;margin-top:5px">剩余金额≥</span>
                              <el-input v-if="activeNamesyks==4 || activeNamesyks==5"  size="mini" style="width:80px;"   v-model="Amount2" ></el-input> 
                              <span v-if="activeNamesyks==4 || activeNamesyks==5" style="font-size: 12px;width:60px;margin-top:5px">剩余金额≤</span>
                              <el-input v-if="activeNamesyks==4 || activeNamesyks==5" size="mini"  style="width:80px;"   v-model="Amount1" ></el-input> 
                                 <span v-if="activeNamesyks==1 || activeNamesyks==3 || activeNamesyks==5" style="font-size: 12px;width:60px;margin-top:5px">剩余天数≥ </span>
                                <el-input v-if="activeNamesyks==1 || activeNamesyks==3 || activeNamesyks==5" size="mini" style="width:80px;"  v-model="CardDays2"  ></el-input> 
                               <span v-if="activeNamesyks==1 || activeNamesyks==3 || activeNamesyks==5" style="font-size: 12px;width:60px;margin-top:5px">剩余天数≤ </span>
                                <el-input v-if="activeNamesyks==1 || activeNamesyks==3 || activeNamesyks==5" size="mini" style="width:80px;"  v-model="CardDays1"  ></el-input> 
                                <el-select v-model="selectCardID" clearable placeholder="请选择卡总"    size="mini">
                                   <el-option v-for="item in cardList"
                                        :key="item.ID"
                                        :label="item.CardName"
                                        :value="item.ID"
                                      ></el-option> 
                                 </el-select> &nbsp;&nbsp;
                                <el-select size="mini" v-model="OderType"  >
                                    <el-option label="次数排序" value="1"></el-option>
                                    <el-option label="天数排序" value="2"></el-option>
                                </el-select>&nbsp;&nbsp;   
                                 <el-input size="mini" :placeholder="searchPlaceholder"  style="width:170px"  v-model="searchContent" ></el-input>&nbsp;&nbsp;
                                &nbsp;&nbsp;
                                <el-button size="mini" type="primary" @click="searchClick1">搜索</el-button>
                                 &nbsp;&nbsp;
                                
                            </div>
                            
                </div>
            </div>
               <el-tabs v-model="activeNamesyks" @tab-click="handleClick2" class="topTabs1">

                <el-tab-pane  label="次卡(有期限)" name="1" >
                    <el-table :data="MemberYJList"  
                    size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                     <el-table-column label="会员" prop="Name"   >
                            </el-table-column>
                            <el-table-column label="手机" prop="Phone"  ></el-table-column>
                            <el-table-column label="会员卡" prop="CardName"  ></el-table-column>
                             <el-table-column label="卡类别" prop="CardType" :formatter="stateFormat1" ></el-table-column>
                            <el-table-column label="到期时间"  >
                                <template slot-scope="scope"  >
                                   <span  v-if="scope.row.CardType =='1'">{{scope.row.OverdueTime}}</span>
                                   <span  v-if="scope.row.CardType =='3'">{{scope.row.OverdueTime}} </span>
                                 </template>
                            </el-table-column>
                            <el-table-column label="剩余数量" prop="" >
                                <template slot-scope="scope"  >
                                  <span style="color: red;" v-if="scope.row.CardType =='1'">{{scope.row.CardNumber}}次 （{{scope.row.CardDays}} 天）</span>
                                  <span style="color: red;" v-if="scope.row.CardType =='2'">{{scope.row.CardNumber}}次 </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='3'">{{scope.row.CardDays}} 天  </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='4'">{{scope.row.Amount}}元 </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='5'">{{scope.row.Amount}}元 （{{scope.row.CardDays}} 天） </span>
                                </template>
                            </el-table-column>
 
                        </el-table>   
                        <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane  label="次卡(无期限)" name="2"  >
                    <el-table :data="MemberYJList" 
                       size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                     <el-table-column label="会员" prop="Name"   >
                            </el-table-column>
                            <el-table-column label="手机" prop="Phone"  ></el-table-column>
                            <el-table-column label="会员卡" prop="CardName"  ></el-table-column>
                             <el-table-column label="卡类别" prop="CardType" :formatter="stateFormat1" ></el-table-column>
                            <el-table-column label="剩余数量" prop="" >
                                <template slot-scope="scope"  >
                                  <span style="color: red;" v-if="scope.row.CardType =='1'">{{scope.row.CardNumber}}次 （{{scope.row.CardDays}} 天）</span>
                                  <span style="color: red;" v-if="scope.row.CardType =='2'">{{scope.row.CardNumber}}次 </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='3'">{{scope.row.CardDays}} 天  </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='4'">{{scope.row.Amount}}元 </span>
                                  <span style="color: red;" v-if="scope.row.CardType =='5'">{{scope.row.Amount}}元 （{{scope.row.CardDays}} 天） </span>

                                </template>

                            </el-table-column>
 
                        </el-table>   
                        <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane  label="期限卡" name="3"  >
                    <el-table :data="MemberYJList" 
                       size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                     <el-table-column label="会员" prop="Name"   >
                          
                        </el-table-column>
              
                        <el-table-column label="手机" prop="Phone"  ></el-table-column>
                        <el-table-column label="会员卡" prop="CardName"  ></el-table-column>
                         <el-table-column label="卡类别" prop="CardType" :formatter="stateFormat1" ></el-table-column>
                            <el-table-column label="到期时间" prop=""  >
                            <template slot-scope="scope"  >
                               <span  v-if="scope.row.CardType =='1'">{{scope.row.OverdueTime}}</span>
                               <span  v-if="scope.row.CardType =='3'">{{scope.row.OverdueTime}} </span>
                             </template>
                        </el-table-column>
                        <el-table-column label="剩余数量" prop=""  >
                            <template slot-scope="scope"  >
                              <span style="color: red;" v-if="scope.row.CardType =='1'">{{scope.row.CardNumber}}次 （{{scope.row.CardDays}} 天）</span>
                              <span style="color: red;" v-if="scope.row.CardType =='2'">{{scope.row.CardNumber}}次 </span>
                              <span style="color: red;" v-if="scope.row.CardType =='3'">{{scope.row.CardDays}} 天  </span>
                              <span style="color: red;" v-if="scope.row.CardType =='4'">{{scope.row.Amount}}元 </span>
                               <span style="color: red;" v-if="scope.row.CardType =='5'">{{scope.row.Amount}}元 （{{scope.row.CardDays}} 天） </span>

                            </template>

                        </el-table-column>
 
                        </el-table>   
                        <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane  label="储蓄卡(无期限)" name="4"  >
                    <el-table :data="MemberYJList" 
                       size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                     <el-table-column label="会员" prop="Name"   >
                               
                              </el-table-column>
                      
                              <el-table-column label="手机" prop="Phone" ></el-table-column>
                              <el-table-column label="会员卡" prop="CardName"  ></el-table-column>
                               <el-table-column label="卡类别" prop="CardType" :formatter="stateFormat1" ></el-table-column>
                            
                              <el-table-column label="剩余数量" prop="" >
                                  <template slot-scope="scope"  >
                                    <span style="color: red;" v-if="scope.row.CardType =='1'">{{scope.row.CardNumber}}次 （{{scope.row.CardDays}} 天）</span>
                                    <span style="color: red;" v-if="scope.row.CardType =='2'">{{scope.row.CardNumber}}次 </span>
                                    <span style="color: red;" v-if="scope.row.CardType =='3'">{{scope.row.CardDays}} 天  </span>
                                    <span style="color: red;" v-if="scope.row.CardType =='4'">{{scope.row.Amount}}元 </span>
                                   <span style="color: red;" v-if="scope.row.CardType =='5'">{{scope.row.Amount}}元 （{{scope.row.CardDays}} 天） </span>
  
                                  </template>
  
                              </el-table-column>
 
                        </el-table>   
                        <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane  label="储蓄卡(有期限)" name="5"  >
                    <el-table :data="MemberYJList" 
                       size="small"
                    :row-key="row => row.index" 
                     :header-cell-style="{'background-color':'#f8f8f8'}" style="width: 100%;margin:auto" >
                     <el-table-column label="会员" prop="Name"   >
                               
                              </el-table-column>
                      
                              <el-table-column label="手机" prop="Phone" ></el-table-column>
                              <el-table-column label="会员卡" prop="CardName"  ></el-table-column>
                               <el-table-column label="卡类别" prop="CardType" :formatter="stateFormat1" ></el-table-column>
                               <el-table-column label="到期时间" prop=""  >
                                  <template slot-scope="scope"  >
                                     <span  v-if="scope.row.CardType =='1'">{{scope.row.OverdueTime}}</span>
                                     <span  v-if="scope.row.CardType =='3'">{{scope.row.OverdueTime}} </span>
                                     <span  v-if="scope.row.CardType =='5'">{{scope.row.OverdueTime}} </span>
                                   </template>
                              </el-table-column>
                              <el-table-column label="剩余数量" prop="" >
                                  <template slot-scope="scope"  >
                                    <span style="color: red;" v-if="scope.row.CardType =='1'">{{scope.row.CardNumber}}次 （{{scope.row.CardDays}} 天）</span>
                                    <span style="color: red;" v-if="scope.row.CardType =='2'">{{scope.row.CardNumber}}次 </span>
                                    <span style="color: red;" v-if="scope.row.CardType =='3'">{{scope.row.CardDays}} 天  </span>
                                    <span style="color: red;" v-if="scope.row.CardType =='4'">{{scope.row.Amount}}元 </span>
                                   <span style="color: red;" v-if="scope.row.CardType =='5'">{{scope.row.Amount}}元 （{{scope.row.CardDays}} 天） </span>
  
                                  </template>
  
                              </el-table-column>
 
                        </el-table>   
                        <div class="Pagination userPagination">
                    <el-pagination
                     @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                     :current-page.sync="currentPage2"
                     :page-sizes="[10,20,30,40]"
                     :page-size="limit2"
                    layout="total,prev,pager,next,sizes,jumper"
                    :total="count2">
                    </el-pagination>
                    </div>
                  </el-tab-pane>
              </el-tabs>
        </el-tab-pane>
    </el-tabs>
  <el-dialog title="编辑提成" :visible.sync="mainShow" width="40%" @click="mainShow = false">
      <el-form label-width="120px" >
        <el-form-item label="提成类型：" prop="StaffName">
         <el-radio-group v-model="tctype" @change="changeitems(items)">
                      <el-radio :label="1" v-if="ct !=2">按次数</el-radio>
                      <el-radio :label="2">按人数</el-radio>
                    </el-radio-group>
        </el-form-item>
        <el-form-item label="提成金额：" prop="StaffName">
           <el-input-number size="small" v-model="num" :precision="1" :step="0.1" :min="0"></el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="mainShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="sub()">保存</el-button>
      </div>
  </el-dialog>

  <el-dialog title="编辑提成" :visible.sync="mainShow1" width="40%" @click="mainShow1 = false">
      <el-form label-width="120px" >
        <el-form-item label="提成类型：" prop="StaffName">
         <el-radio-group v-model="tctype" >
                      <el-radio :label="1" >按次数</el-radio>
                      <el-radio :label="2">按人数</el-radio>
                    </el-radio-group>
        </el-form-item>
        <el-form-item label="提成金额：" prop="StaffName">
           <el-input-number size="small" v-model="num" :precision="1" :step="0.1" :min="0"></el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="mainShow1 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="sub1()">保存</el-button>
      </div>
  </el-dialog>
  
  <el-dialog title="提成详情" :visible.sync="showInfo" width="70%" @click="showInfo = false">
            <el-table :data="listInfo" highlight-current-row v-loading="loading" size="mini"    element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                <el-table-column label="订单号" prop="OrderCode" ></el-table-column>
               
                <el-table-column label="商品名称" prop="CommodityName" ></el-table-column>
                <el-table-column label="提成价格"  prop="PriceTC" ></el-table-column>         
                <el-table-column label="创建时间" prop="addTime"></el-table-column>
              
             </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </el-dialog>

 
   <el-dialog title="课时详情" :visible.sync="dialogNameVisiblels" width="70%" @click="dialogNameVisiblels = false">
          <el-table :data="ListPreAboutInfo" highlight-current-row v-loading="loading" size="mini"    element-loading-text="拼命加载中" style="width:100%;margin-top:10px">

                 <el-table-column label="姓名" prop="Name" >
               </el-table-column>
               <el-table-column label="手机号" prop="Phone"  ></el-table-column>
               <el-table-column label="上课时间" prop="SKtime" >
                 <template slot-scope="scope">
                  <span>{{scope.row.beizhu}}  </span>
                    </template>
               </el-table-column>
               <el-table-column label="会员卡" prop="CardName"  ></el-table-column>

               <el-table-column label="消耗" prop="xhJine"  >
                <template slot-scope="scope"  >
                                    <span v-if="scope.row.CardType==1 || scope.row.CardType==2">{{scope.row.CardNumber}}</span>
                                    <span v-if="scope.row.CardType==3">1</span>
                                    <span v-if="scope.row.CardType==4 || scope.row.CardType==5">{{scope.row.Amount}}</span>
                  </template>
               </el-table-column>
               <el-table-column label="单价" prop="djValue">
                             </el-table-column>
               <el-table-column   label="费用" prop="xhAmount"  ></el-table-column>

                  </el-table>   
           <div class="Pagination userPagination">
                     <el-pagination
                      @size-change="handleSizeChange1"
                     @current-change="handleCurrentChange1"
                      :current-page.sync="currentPage1"
                      :page-sizes="[10,20,30,40]"
                      :page-size="limit1"
                     layout="total,prev,pager,next,sizes,jumper"
                     :total="count1">
                     </el-pagination>
                   </div>  
     
          

     </el-dialog>
    <!-- 搜索筛选 -->
  </div>
</template>
<script>

import Pagination from "../../components/Pagination";
 import { baseUrl } from "../../config/env.js";
 import { ajax } from "../../config/fetch.js";
 import {getLoginToken} from "@/api/getData";
export default {
  data() {
    return {
      OrderType:'',
      open:true,
      tctype:1,
      num:1,
      activeNamesk:'skphb',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      SelectStoresID:localStorage.getItem("StoresID"),
      iscdyy:localStorage.getItem("iscdyy"),
      iszjyy:localStorage.getItem("iszjyy"),
      WZCDName: localStorage.getItem('WZCDName'),
      list:[],
      list1:[],
      list2:[],
      list3:[],
      list4:[],
      list5:[],
      list6:[],
      list10:[],
      list11:[],
      SelectCardID:'',
      selectCardID:'',
      searchContent:'',
      activeName:'0',
      stype:"0",
      objID:'',
      TerID:'',
      SiteTypeID:'',
      SiteID:'',
      firstdate8:[],
      typeList:[],
      ListSite:[],
      RowTypeList:[],
      minDate8:'',
      maxDate8:'',
      cardList:[],
      proList:[],
      proList1:[],
      ct:'',
      title: "添加",
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      isCard:localStorage.getItem("isCard"),
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      personList:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      name:'',
      tableData:[],
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZCDName:'',
    WZPBName:'',
    mainList:'',
    mainShow:false,
    mainShow1:false,
    Limits:[],
    isCashier:'',
    q1:false,
    q2:false,
    q3:false,
    q4:false,
    q5:false,
    q6:false,
    sTime:'',
    eTime:'',
    
    SelectName:'',
    OrderCode:'',
    row:{},
    showInfo:false,
    dialogNameVisiblels:false,
    listInfo:[],
    list4:[],
    ListPreAboutInfo:[],
    limit1: 10,
                count1:1,
                currentPage1:1,
                offset1:1,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      searchContent:"",
                 CardDays2:"0", 
                CardDays1:"30", 
                Amount1:"500", 
                Amount2:"0",
                CardNumber1:"30", 
                CardNumber2:"0", 
                activeNamesyks:"1",
                OderType:"1", 
                CardType:"1", 
                searchPlaceholder:"搜索姓名/手机号",
                limit2: 10,
                count2:0,
                currentPage2:1,
                offset2:1,
                MemberYJList:[],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
  this.isCashier = localStorage.getItem('isCashier')
if(this.isCard == 0 ){
  this.activeNamesk = 'yyephb'
}

if(localStorage.getItem('StoresType') == 1){
          this.name = '签到'
         
      }  else {
          this.name = '核销'

      }    
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName')

   if(localStorage.getItem('isAdmin') == 1){
          
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 =true
   
      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 112)
            this.q1  =true
            if(items == 113)
            this.q2 = true
            if(items == 114)
            this.q3 = true
            if(items == 115)
            this.q4 = true
      })
      if(this.q1 == true){
        this.activeName = '0'
      }
      if(this.q1 == false && this.q2 == true){
        this.activeName == '1'
      }
      if(this.q1 == false && this.q2 == false && this.q3 == true){
        this.activeName == '2'
      }
      if(this.q1 == false && this.q2 == false && this.q3 == false && this.q4 == true){
        this.activeName == '3'
      }
      if(this.iscdyy==1){
          this.activeName ='0';
          this.getList7()
         }else{
        this.getList()

        }
        this.getDianList()
        this.getProject()
        this.getProject1()

        
        this.getCard()
        this.getPersonList()
        this.getRowType()
   
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    lookInfo(row){
        this.pageparm = {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      }
     this.formInline.page = 1
     this.formInline.limit = 10
     this.row = row
     this.getlistInfo()
  },

    getlistInfo(){
      console.log(this.formInline)
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          GMtime1:this.firstdate8[0],
          GMtime2:this.firstdate8[1],
          StaffID: this.row.StaffID,
          pages:this.formInline.page,
          psize:this.formInline.limit,
      }
  
      var that = this
      this.ajax('getListPayOrderGSTJInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.showInfo = true
                 res.data.forEach(items => {
                      items.addTime = items.addTime.replace(/\//g, '-')
                
                    });
                that.listInfo = res.data
                that.pageparm.total = res.allcount
        } 
       })
    },
        getRowType(){
          this.ct = 1
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                if(res.data.length == 1){
                  if(res.data[0].RowType == 2){
                        that.ct = 2
                  }
                }
                that.RowTypeList = res.data
    
          } 
       })
    },sub1(){
       var data = { 

          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SiteID:this.mainList.SiteID,
          StaffID:this.mainList.StaffID,
          tctype:this.tctype,
          tcAmount:this.num

        }
      var that = this
      this.ajax('addSiteStaffAmountTJ.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "编辑成功",duration:2000,
              });

             that.getList7()
             that.mainShow1 = false
                
          } 
       })
    },
    sub(){
       var data = { 

          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ProjectID:this.mainList.ProjectID,
          StaffID:this.mainList.StaffID,
          tctype:this.tctype,
          tcAmount:this.num

        }
      var that = this
      this.ajax('addProjectStaffAmountTJ.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "编辑成功",duration:2000,
              });

             that.getList()
             that.mainShow = false
                
          } 
       })
    },ticheng1(row){
        this.mainList = row
        this.mainShow1 = true
        
        this.tctype = 2
        this.num = 1
    },
    ticheng(row){
        this.mainList = row
        this.mainShow = true
        
        this.tctype = 2
        this.num = 1
    },
    handleClick1(tab, event) {
        this.stype="0";
        this.OrderType="0";
        this.minDate5='';
        this.maxDate5='';
        this.getList3();
        
      },
    getList3(){
        if(this.activeNamesk == 'skphb'){
          var data = { 
              SelectStoresID:this.SelectStoresID,
              token: localStorage.getItem("token"),
              StoresID:localStorage.getItem("StoresID"),
              pages:this.formInline.page,
              psize:this.formInline.limit,
              stype:this.stype,
              Stime:this.minDate8,
              Etime:this.maxDate8,
              OrderType:this.OrderType
       }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getTopTurnover.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list3 = res.listall
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
            loading.close();
      })
    
        } else {
           var data = { 
              SelectStoresID:this.SelectStoresID,
              token: localStorage.getItem("token"),
              StoresID:localStorage.getItem("StoresID"),
              pages:this.formInline.page,
              psize:this.formInline.limit,
              stype:this.stype,
              Stime:this.minDate8,
              Etime:this.maxDate8,
              OrderType:this.OrderType
       }
        var that = this
          if(this.isCard == 1){
 this.ajax('getTopTurnoverAmount.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list3 = res.listall
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }

      })
          } else {
             this.ajax('getTopTurnoverNoCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list3 = res.listall
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }

      })
          }
         
      

      }
      
    },
    getPersonList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:0
      }
     
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            if(that.activeName==1){
                 let items ={ ID:'-1',Name:'全部'}
                 let items1 ={ ID:'0',Name:'门店'}
                  that.personList.push(items);
                  that.personList.push(items1);
            }
                
                  res.data.forEach(items2=>{
                   that.personList.push(items2);

              })


          } 

      })
    },
    getProject(){
         var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          ProjectTypeID:0
          // StaffTypeID:this.active
      }
      
      var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.proList = res.data
              
          } 

      })
    },
    getProject1(){
        

      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,
      }

      var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            that.tableLoading = false
            that.proList1 = res.data
          } 

      })
    },
    getCard(){
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }


      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {    
                that.cardList= res.data


          } 
       })
    },
    handleSearchCoursetopsy(){

        if(this.stype=='2' && this.activeName == '0' ){
            if(this.minDate8 !='' && this.maxDate8 !=''){
                        
                    if(this.activeName  == 0){
                      if(this.iscdyy==1){
                        this.getList7()

                      }else{
                        this.getList()

                      }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                    if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
                  }
                }else if(this.stype=='4' && this.activeName != '0')
                {
                   
                      if(this.minDate8 !='' && this.maxDate8 !=''){
                        
                        if(this.activeName  == 0){
                          if(this.iscdyy==1){
                        this.getList7()

                      }else{
                                this.getList()
                              }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                      if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
                  }
                 } else{  if(this.activeName  == 0){
                  if(this.iscdyy==1){
                        this.getList7()

                      }else{
                    this.getList()
                    }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                   if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
        }
    },
        selectDat8(e){
            console.log(this.firstdate8)
              this.maxDate8 = this.firstdate8[1]
              this.minDate8 = e
            if( this.minDate8 > this.maxDate8){
           
              console.log(this.maxDate8)
              this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
                    return;
                
            }

                if(this.activeName  == 0){
                  if(this.iscdyy==1){
                        this.getList7()

                      }else{
                        this.getList()
                      }
                   

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                      if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
    },
        selectDat9(e){

              this.minDate8 = this.firstdate8[0]
              this.maxDate8 = e
            if( this.minDate8 > this.maxDate8){
              console.log(this.minDate8)
              console.log(this.maxDate8)
              this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
                    return;
                
            }

                if(this.activeName  == 0){
                  if(this.iscdyy==1){
                        this.getList7()

                      }else{
                        this.getList()
                      }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                     if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
    },
    callFather(parm){
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getlistInfo()
          // if(this.activeName  == 0){
          //             this.getList()

          //           } 
          //           if(this.activeName  == 1){
          //                    this.getList1()
                
          //           }
          //           if(this.activeName  == 2){
          //                 this.getList2()
          //           }
          //             if(this.activeName  == 3){
          //                 this.getList3()
          //           }
          //            if(this.activeName  == 4){
          //                 this.getList4()
          //           }

    },
    getList4(){

        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          SelectStaffID: this.TerID
    
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getListPayOrderGSTJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.list4 = res.data
                // that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
            loading.close();

      })
    },
      handleClick(){
        this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
        }
        this.stype = '0'
        this.objID =''
        this.TerID = ''
        this.OrderType = ''
        this.SelectCardID = ''
        this.personList =[];
        this.typeList =[];
        this.ListSite=[];
        this.getPersonList();
        this.getType();
        this.getListSite();

         if(this.activeName  == 0){
                    if(this.iscdyy==1){
                        this.getList7()

                      }else{
                      this.getList()
                    }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                      if(this.activeName  == 4){
                          this.getList4()
                    } if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }if(this.activeName  == 10){
                      this.sTime ='';
                      this.eTime ='';
                      this.SelectName='';

                          this.getList10()
                    }
                    if(this.activeName  == 11){
      
                      this.SelectName='';

                          this.getList11()
                    }
                    if(this.activeName  == 12){
                      this.activeNamesyks ="1";
                      this.CardDays1="30";
                      this.Amount1="500"; 
                      this.Amount2="0";
                      this.CardNumber1="30";
                      this.CardNumber2="0"; 
                      this.selectCardID ="";
                      this.searchContent ="";
                      this.CardType ="1";
                      this.OderType='1';
                      this.offset2 = 1;
                      this.getListSYKSMembers();
                    }

    },
    getListSite(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:1000,
          SiteTypeID:0
       }
       
      
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.ListSite = res.data
           } 

      })
  
    }, getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:1000,
      }
      var that = this
      this.ajax('getListSiteType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList(){
       var TerID
       if(this.TerID == ''){
         TerID = -1
       } else {
         TerID = this.TerID
       }
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          TerID:TerID,
          objID:this.objID
      }
      const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        var that = this
       this.ajax('getStafftctj.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list = res.listall
                that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
           loading.close();

      })
    },
    getList7(){
       var TerID
       if(this.TerID == ''){
         TerID = -1
       } else {
         TerID = this.TerID
       }
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          TerID:TerID,
          objID:this.objID
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getSiteStafftctj.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list = res.listall
                that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
              loading.close();

      })
    },
    getList5(){
 
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          SiteTypeID:this.SiteTypeID
       }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getPreAboutCDTypeTJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list5 = res.listall
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
            loading.close();

      })
    },getList6(){
 
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          SiteID:this.SiteID
       }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getPreAboutCDSiteTJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list6 = res.listall
                 var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
              loading.close();

      })
    },searchHYSKFY(){
      this.getList10();
    },getList10(){
 
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          stype:this.stype,
          sTime:this.sTime,
          eTime:this.eTime,
          SelectName:this.SelectName
        }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        this.ajax('getListOrderRecordTJ.aspx',JSON.stringify(data),"POST",function(res){

            if (res.orsuccess == "1") {
                that.list10 = res.data
                  var Stime = res.sTime;
                var Etime = res.eTime;
                that.sTime = Stime;
                that.eTime = Etime;
                
            }
              loading.close();

        })
},getOrderRecordTJClick(row){
        this.OrderCode = row.OrderCode;
        this.getListOrderRecordTJInfo();

      },handleSizeChange1(val){
        this.limit1 = val;
        this.currentPage1 = 1;
        this.offset1 = 1;
        
        this.getListOrderRecordTJInfo();                  
      },
      // 当前页变动时候触发的事件
      handleCurrentChange1(val) {
        this.currentPage1 = val;
        this.offset1 =val;
        this.getListOrderRecordTJInfo();
                
      },getListOrderRecordTJInfo(){
 
          var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            stype:this.stype,
            sTime:this.sTime,
            eTime:this.eTime,
            OrderCode:this.OrderCode,
            pages:this.offset1,//当前页
             psize:this.limit1,//一页几条
          }
          var that = this
          const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
          this.ajax('getListOrderRecordTJInfo.aspx',JSON.stringify(data),"POST",function(res){

            if (res.orsuccess == "1") {
                  that.ListPreAboutInfo = res.data
                  that.count1 = res.allcount
                  that.dialogNameVisiblels = true;
                  
              }
                loading.close();

          })
},
    getList1(){
     var TerID
       if(this.TerID == ''){
         TerID = -1
       } else {
         TerID = this.TerID
       }
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          SelectterID:TerID,
          SelectCardID:this.SelectCardID
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       if(this.isCard == 1){
          this.ajax('getTerTurnoverSK.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list1 = res.listall
                that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
              loading.close();
      })
       } else {
  this.ajax('getTerTurnoverSKNoCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list1 = res.listall
                that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
            loading.close();
      })
       }

     
    },
    getList2(){
          var TerID
       if(this.TerID == ''){
         TerID = -1
       } else {
         TerID = this.TerID
       }
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          stype:this.stype,
          Stime:this.minDate8,
          Etime:this.maxDate8,
          SelectCardID:this.SelectCardID
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getCradTurnover.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list2 = res.listall
                that.pageparm.total = res.allcount
                var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
               
            }
            loading.close();
      })
    },

    changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
       if(this.activeName  == 0){
                     if(this.iscdyy==1){
                        this.getList7()

                      }else{
                      this.getList()
                    }

                    } 
                    if(this.activeName  == 1){
                             this.getList1()
                
                    }
                    if(this.activeName  == 2){
                          this.getList2()
                    }
                      if(this.activeName  == 3){
                          this.getList3()
                    }
                      if(this.activeName  == 4){
                          this.getList4()
                    }
                    if(this.activeName  == 5){
                          this.getList5()
                    } if(this.activeName  == 6){
                          this.getList6()
                    }
      // this.getImg()
    },
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },

    // 分页插件事件

    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },searchHYFY(){
      this.getList11();
    },getList11(){
 
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SelectName:this.SelectName
        }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        this.ajax('getMembersRecordvip.aspx',JSON.stringify(data),"POST",function(res){

            if (res.orsuccess == "1") {
                that.list11 = res.data
               
                
            }
              loading.close();

        })
},handleClick2(tab, event){
  this.CardDays2="0"; 
                 this.CardDays1="30";
                 this.Amount1="500"; 
                 this.Amount2="0";
                 this.CardNumber1="30";
                 this.CardNumber2="0"; 
                 this.selectCardID ="";
               if(tab.name == "1"){
                   this.CardType ="1";
                   this.OderType='1';
                 this.offset2 = 1;
                     this.getListSYKSMembers();
                }else if(tab.name == "2"){
                   this.CardType ="2";
                this.offset2 = 1;
                   this.getListSYKSMembers();
                }else if(tab.name == "3"){
                   this.CardType ="3";
                this.offset2 = 1;
                   this.getListSYKSMembers();
                }else if(tab.name == "4"){
                 this.CardType ="4";
                this.offset2 = 1;
                this.getListSYKSMembers();

                }else if(tab.name == "5"){
                    this.OderType='1';
                 this.CardType ="5";
                this.offset2 = 1;
                this.getListSYKSMembers();

                }  
                this.getCard()
},handleSizeChange2(val){
        this.limit2 = val;
        this.currentPage2 = 1;
        this.offset2 = 1;
        this.getListSYKSMembers();
      },
      // 当前页变动时候触发的事件
      handleCurrentChange2(val) {
        this.currentPage2 = val;
        this.offset2 =val;
        this.getListSYKSMembers();
      
      },handleSearchOrderType(){
                this.offset2 = 1;
                this.getListSYKSMembers();
            },stateFormat1(row, column) {
                    if (row.CardType === '1') {
                        return '次卡（有期限）'
                        } if (row.CardType === '2') {
                        return '次卡（无限期）'
                        } if (row.CardType === '3') {
                        return '期限卡'
                        } if (row.CardType === '4') {
                        return '储蓄卡（无限期）'
                        }else  {
                        return '储蓄卡（有限期）'
                        } 
              },searchClick1(){
                if(this.CardNumber2>this.CardNumber1){
                        this.$alert('剩余次数≥数不可以大于剩余次数≤数', '提示', {
                                confirmButtonText: '关闭',
                                callback: action => {
                                    
                                }
                                });
                                return;
                }
                if(this.CardDays2>this.CardDays1){
                     this.$alert('剩余天数≥数不可以大于剩余天数≤数', '提示', {
                                confirmButtonText: '关闭',
                                callback: action => {
                                    
                                }
                                });
                                return;
                }
                if(this.Amount2>this.Amount1){
                     this.$alert('剩余金额≥数不可以大于剩余金额≤数', '提示', {
                                confirmButtonText: '关闭',
                                callback: action => {
                                    
                                }
                                });
                                return;
                }
                this.offset2 = 1;
                this.getListSYKSMembers();

            },getListSYKSMembers(){
 
 var data = { 
   SelectStoresID:this.SelectStoresID,
   token: localStorage.getItem("token"),
   StoresID:localStorage.getItem("StoresID"),
   SelectName:this.searchContent,
                    CardType:this.CardType,
                    OderType:this.OderType,
                    CardDays1:this.CardDays1,
                    CardDays2:this.CardDays2,
                    Amount1:this.Amount1,
                    Amount2:this.Amount2,
                    CardNumber1:this.CardNumber1,
                    CardNumber2:this.CardNumber2,
                    selectCardID:this.selectCardID,
                    pages:this.offset2,//当前页
                    psize:this.limit2,//一页几条
 }
 var that = this
 const loading = this.$loading({
       lock: true,
       text: '加载中...',
       spinner: 'el-icon-loading',
       background: 'rgba(0, 0, 0, 0.7)'
     });
 this.ajax('getListSYKSMembers.aspx',JSON.stringify(data),"POST",function(res){

     if (res.orsuccess == "1") {
      that.MemberYJList = res.data;
      that.count2 = res.allcount;
                  
        
         
     }
       loading.close();

 })
},
     
    
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style scoped>
.rankingList___2qU5M li span:last-child {
    float: right;
}
.rankingList___2qU5M li span.active___3n5dI {
    background-color: #fab938 !important;
    color: #fff !important;
}
.rankingList___2qU5M li span:first-child {
    background-color: #f5f5f5;
    border-radius: 20px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    color:black;
}
.rankingList___2qU5M li{
    zoom: 1;
    margin-top: 16px;
}
.rankingList___2qU5M li span {
    color: rgba(0,0,0,.65);
    font-size: 12px;
    line-height: 22px;
}
.rankingList___2qU5M {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    height: 300px;
    overflow:auto;
}
.bottomTitle{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    line-height: 20px;
}
.bottomTitle1{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    /* line-height: 20px; */
}
.rmb{
  font-size: 12px; line-height: 1;
}
.money{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
}
.textTitle{
    margin-right: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
    line-height: 22px;
}
 .box{
    cursor: pointer;
    width: 17%;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
   .boxx{
    cursor: pointer;
    width: 25%;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .box1{
 
    width: 74.7%;
    height: 362px;
    /* padding: 20px; */
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    /* border: 1px solid #ececec; */
    /* box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%); */
  }
  .box2{
    cursor: pointer;
    width: 24%;
    height: 362px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .pm{
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
  }

 .box3{
    cursor: pointer;
    width: 24%;
    height: 130px;
    
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box3Ttile{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
  }
  .num{
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
  }
   .box4{
    cursor: pointer;
    width: 24%;
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
   border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
 .box5{
    cursor: pointer;
    height: 200px;
    width:180px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
</style>

 



// WEBPACK FOOTER //
// src/views/statistics/statistics.vue